import { useEffect, useState } from "react";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import clsx from "clsx";
import { styled } from "@mui/material";

const TimePickerStyled = styled(TimePicker)({
  width: "150px",
  "& .html-input": {
    paddingRight: 0,
  },
});

const TimeField = ({
  label,
  placeholder,
  isDisabled,
  isViewMode,
  value,
  defaultValue,
  onChange,
  isError,
  helperText,
  format = "kk:mm",
  className,
  classNames = {}, // root, input, label
  minTime,
  maxTime,
  style,
  locale = "en",
  isAmPm,
  textFieldProps,
}) => {
  const [timeValue, setTimeValue] = useState(defaultValue || value || null);

  const handleTimeChange = (time) => {
    setTimeValue(time);
    onChange?.(time);
  };

  useEffect(() => {
    setTimeValue(value || null);
  }, [value]);

  useEffect(() => {
    setTimeValue(defaultValue || null);
  }, [defaultValue]);

  return (
    <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={locale}>
      <TimePickerStyled
        value={timeValue}
        minTime={minTime}
        maxTime={maxTime}
        ampm={isAmPm}
        ampmInClock={isAmPm}
        onChange={handleTimeChange}
        disabled={isDisabled}
        format={format}
        slotProps={{
          textField: {
            label,
            error: Boolean(isError),
            helperText,
            disabled: isViewMode || isDisabled,
            inputProps: {
              placeholder: isViewMode ? "" : placeholder,
              readOnly: true,
              ...textFieldProps?.inputProps,
            },
            InputProps: {
              className: clsx(
                "input",
                { "view-mode": isViewMode },
                classNames.input
              ),
              ...textFieldProps?.InputProps,
            },
            InputLabelProps: {
              shrink: false,
              className: clsx("label", classNames.label),
            },
            className: clsx(
              "root",
              { "view-mode": isViewMode },
              className,
              classNames.root
            ),
            style,
            ...textFieldProps,
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default TimeField;
